export function driverTipModel(data) {
    const { predefinedValues, maxValue, enabled } = data || {};
    return {
        predefinedValues: predefinedValues || [],
        maxValue: maxValue || 0,
        enabled: enabled || false
    }
};
